'use strict';

angular.module('shiftTraderApp')
  .controller('SaPhoneNumbersProfileCtrl', function ($scope, PhoneResource, UserPermissionsService, regexStrings) {

    $scope.regexStrings = regexStrings;

    $scope.state = {
      rawPermissions: null,
      desiredPermissions: null
    };

    var permissionsToLookUp = [
      'users.update_my_phone_number',
      'users.view_info_in_org',
      'users.update_phone_number',
    ];

    UserPermissionsService.getCanDict(permissionsToLookUp, 'current')
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;
        processRawPermissions();
      });

    function processRawPermissions() {
      var myProf = $scope.me.id === $scope.user.id;
      var rawPerm = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canChangePhoneNumber: (myProf && rawPerm['users.change_my_phone_number'] ||
          rawPerm['users.update_phone_number']),
        canViewPhoneNumber: (myProf || rawPerm['users.view_info_in_org'] || $scope.me.memberships[0].share_phone_with_coworkers)
      };
    }


    $scope.setShowAddPhoneNumber = function(val) {
      $scope.showAddPhoneNumber = val;
    };

    $scope.removePhoneNumber = function(index) {
      $scope.user.phone_numbers[index].$delete({
          'user_id':$scope.user.phone_numbers[index].user_id,
          'id': $scope.user.phone_numbers[index].id
        },
        function() {
          $scope.user.phone_numbers.splice(index,1);
          $scope.showAddPhoneNumber = false;
        },
        function() {
          console.log('Phone number removal failed.');
        }
      );
    };

    $scope.addPhoneNumber = function() {
      var data = {
        number: $scope.form.number.replace(/[^0-9]/g, ''),
        primary: false,
        user_id: $scope.user.id,
        organization_id: $scope.user.memberships[0].organization.id
      };

      var newPhone = new PhoneResource(data);
      newPhone.$save({},
        function(p) {
          $scope.form.number = '';
          $scope.user.phone_numbers.push(p);
          $scope.showAddPhoneNumber = false;
        },
        function() {
          console.log('phone number creation failed');
        });

      return newPhone;
    };

    $scope.setPrimaryPhoneNumber = function(index) {
      console.log($scope.user.phone_numbers[index]);
      $scope.user.phone_numbers[index].primary = true;
      $scope.user.phone_numbers[index].$setPrimary({},
        function(d) {
          $scope.user.phone_numbers[index].primary = d.primary;
        },
        function() {
          console.log('Phone number update failed');
        });
    };
  });
